import DaAppContainer from './DaApp.container';
import DaApp from './DaApp';
export default DaAppContainer(DaApp);

//# sourceMappingURL=index.js.map